import Section from "@/components/site/Section";
import Icon from "@/components/site/Icon";
import { Reveal } from "@/components/site/Reveal";
import { SectionHeading } from "@/components/site/primitives";
import { PILLARS } from "@/lib/content";

export default function Pillars() {
  return (
    <Section id="concept" bg="surface">
      <Reveal className="max-w-3xl">
        <SectionHeading overline="The Concept" title={<>Charge the car.<br />Recharge yourself.</>} />
        <p className="mt-6 text-base leading-relaxed text-white/55 md:text-lg">
          RestPower brings six essentials together in one destination — so the time your vehicle spends
          charging becomes useful time for you.
        </p>
      </Reveal>

      <div className="mt-12 grid grid-cols-2 gap-4 md:mt-16 md:grid-cols-3 lg:grid-cols-6">
        {PILLARS.map((p, i) => (
          <Reveal key={p.title} delay={(i % 6) * 0.05}>
            <div className="group h-full rounded-2xl border border-white/10 bg-rp-card p-5 text-center transition-colors duration-300 hover:border-rp-accent/40 md:p-6" data-testid={`pillar-${p.title.toLowerCase()}`}>
              <div className="mx-auto grid h-12 w-12 place-items-center rounded-xl border border-white/10 text-rp-accent transition-colors duration-300 group-hover:border-rp-accent/50 group-hover:shadow-glow-sm">
                <Icon name={p.icon} className="h-6 w-6" strokeWidth={1.5} />
              </div>
              <h3 className="mt-4 font-display text-base font-semibold uppercase tracking-tight text-white md:text-lg">{p.title}</h3>
              <p className="mt-1.5 text-xs leading-relaxed text-white/50 md:text-sm">{p.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </Section>
  );
}
